/* global site imports */

//import 'normalize.css';
import './scss/style.scss';
import './js/site.js';